import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  find,
} from 'lodash';
import {
  Field2 as Field,
  API,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function ProfileInfo({
  className,
  name,
  companyId,
  companyName,
  bannerName,
  tags,
  isAdmin,
  canEdit,
  salesforceId,
  canAssignTag,
  canCreateCompanyBanner,
  onUpdate,
}) {
  const [tag, setTag] = useState('');
  const canAdminEdit = isAdmin && canEdit;

  /**
   * When a field value is changed
   */
  const onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  /**
   * When the tag field is changed
   */
  const onChangeTag = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    setTag(value);
  };

  const onAddTag = (tag) => {
    const existingTag = find(tags, { _id: tag._id });

    // Tag is already added (and not queued for removal)
    if (existingTag && existingTag.status !== 'remove') {
      return;
    }

    onUpdate({
      tags: [
        ...tags,
        {
          ...tag,
          status: 'add',
        },
      ],
    });
  };

  const onRemoveTag = (tag) => {
    const existingTag = find(tags, { _id: tag._id });

    // Tag exists, add a remove status
    if (existingTag && existingTag.initialTag) {
      onUpdate({
        tags: tags.map((t) => {
          if (t._id === existingTag._id) {
            return {
              ...t,
              ...tag,
            };
          }

          return t;
        }),
      });
    } else {
      // Remove the tag
      onUpdate({
        tags: tags.map((t) => {
          if (t._id === tag._id) {
            return {
              ...t,
              status: 'remove',
            };
          }

          return t;
        }),
      });
    }
  };

  /**
 * When the location banner is changed
 */
  const onChangeLocationBanner = ({
    name,
    value,
  }) => {
    onUpdate({
      [name]: value,
    });
  };

  return (
    <div className={classNames('ProfileInfo', className)}>
      <Grid spacing={2} container>
        <Grid
          xs={6}
          lg={isAdmin
            ? 6
            : 12}
          item
        >
          <Field
            type="text"
            label="Location Name"
            placeholder="Location Name"
            name="name"
            value={name}
            tabIndex={1}
            onChange={onChange}
            disabled={!canAdminEdit}
            required
          />
        </Grid>

        {/* <Grid
          xs={6}
          lg={isAdmin
            ? 6
            : 12}
          item
        >
          <Field
            type="text"
            label="Industry"
            value={companyName}
            tabIndex={2}
            companyProps={{
              companyId,
              companyName,
            }}
            required
          />
        </Grid> */}

        {isAdmin && (
          <Grid
            xs={6}
            lg={isAdmin
              ? 6
              : 12}
            item
          >
            <Field
              type="company"
              label="Company"
              value={companyName}
              tabIndex={3}
              companyProps={{
                companyId,
                companyName,
              }}
              disabled
              required
            />
          </Grid>
        )}

        <Grid
          xs={6}
          lg={isAdmin
            ? 6
            : 12}
          item
        >
          <Field
            type="dropdown"
            label="Location Banner"
            name="bannerName"
            value={bannerName}
            tabIndex={4}
            dropdownProps={{
              type: 'banner',
              attr: 'value',
              companyId,
              fetch: API.Company.Banner.list,
              create: API.Company.Banner.create,
              canCreate: canCreateCompanyBanner,
              successMessage: 'COMPANYBANNER.CREATED',
            }}
            disabled={!canAdminEdit}
            onChange={onChangeLocationBanner}
            required
          />
        </Grid>

        {canEdit && (
          <Grid xs={12} lg={6} item>
            <Field
              type="text"
              label="Salesforce ID"
              placeholder="XXXXXXXXXXXXXXXXXX"
              name="salesforceId"
              value={salesforceId}
              tabIndex={5}
              disabled={!canAdminEdit}
              onChange={onChange}
            />
          </Grid>
        )}

        {/* <Grid
          xs={6}
          lg={isAdmin
            ? 6
            : 12}
          item
        >
          <Field
            type="select"
            label="Business Status"
            name="companyName"
            value={companyName}
            options={[
              {
                label: '',
                value: '',
              },
              {
                label: 'Audio',
                value: 'audio',
              },
              {
                label: 'Visual',
                value: 'visual',
              },
            ]}
            tabIndex={6}
            onChange={onChange}
            required
          />
        </Grid> */}

        <Grid xs={12} item>
          <Field
            type="tags"
            label="Tags"
            name="tag"
            placeholder="Input Tags..."
            value={tag}
            tagProps={{
              assign: canAssignTag,
              companyId,
              tags,
              onAdd: onAddTag,
              onRemove: onRemoveTag,
            }}
            tabIndex={7}
            disabled={!canEdit}
            onChange={onChangeTag}
          />
        </Grid>
      </Grid>
    </div>
  );
}

ProfileInfo.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  companyId: PropTypes.string,
  companyName: PropTypes.string,
  salesforceId: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.object),
  isAdmin: PropTypes.bool,
  canEdit: PropTypes.bool,
  canAssignTag: PropTypes.bool,
  onUpdate: PropTypes.func,
};

ProfileInfo.defaultProps = {
  className: '',
  name: '',
  companyId: '',
  companyName: '',
  salesforceId: '',
  tags: [],
  isAdmin: false,
  canEdit: false,
  canAssignTag: false,
  onUpdate: () => {},
};

export default ProfileInfo;
